import { makeStyles } from '@material-ui/core/styles';
import { fontClasses } from '../../fontStyles';
import { styled } from '@material-ui/core/styles';
import * as utility from "../../utils/utility"
const useStyles = makeStyles(theme => ({


    ChargerSettingContainer: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        height: 'auto',
        margin: '16px',
        marginTop: '120px',
    },
    ChargerSettingHeading: {
        width: '100%',
        position: 'relative',
        marginBottom: '6.5px',
    },
    SettingHeading: {
        color: '#6F6F6F',
    },
    SettingBaseLine: {
        fontSize: '13px',
        color: '#7B8793',
    },
    ChargingSettingForwardIcon: {
        marginTop: '-32px ',
        color: '#545456',
        position: 'absolute',
        marginLeft: ' calc(100% - 13px)',
        marginBottom: '16px',
    },

    divider: {
        margin: '11px 0',
    },

    SiteDetailsContainer:{
        overflowY: "auto",
        overflowX: "hidden",
        marginTop: utility.isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        height: utility.isiOS() ? 'calc(91vh - 64px - env(safe-area-inset-top))' : 'calc(91vh - 64px)',
        width: '100% !important',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: `${theme.palette.primary.background} !important`,
        padding: '16px'
    },

    heading: {
        fontSize: '12px',
        fontWeight: '700',
        lineHeight: '16px',
        letterSpacing: '0.02em',
        textAlign: 'left',
        textTransform: 'uppercase',
        fontFamily: "'T-star', 'Visuelt', 'Roboto', 'Helvectica Neue', 'Helvetica', 'Arial', 'sans-serif'",
        color: `${theme.palette.tertiary.headingText2} !important`,
    },

    modelbtn: {
        display: 'flex',
        margin: '8px',
        padding: ' 13px',
        borderRadius: '6.5px',
        textAlign: 'left',
        backgroundColor: `${theme.palette.tertiary.buttonColor} !important`,//'#f8f8fa',
        width: '100% ',
        fontWeight: '450',
        fontSize: '15px',
        color: `${theme.palette.primary.text} !important`,//'#f8f8fa',
        opacity: ' 100%',
        position: 'relative',
    },

    modelbtncontainer: {
        display: 'flex',
        fontSize: '16px',

    },

    ArrowForwardIosIcon: {
        marginTop: '24px ',
        color: '#6F6F6F',
        position: 'absolute',
        marginLeft: ' calc(100% - 56px)',
        marginBottom: '8px',
        zIndex: '1',
    },

    DetailsContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto'
    },

    TrimDetalis: {
        marginTop: "16px",
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        color: `#A9A9AA !important`,
        cursor: 'none',
        minHeight: '44px',
        backgroundColor: `${theme.palette.primary.background}`,
        '& .MuiFormLabel-root ': {
            fontSize:'12px !important',
            fontWeight: '400',
            color: `#A9A9AA !important`,
        },
        '& .MuiInput-root input': {
            borderBottom: "1px",
            fontSize:'12px !important',
            fontWeight: '400',
            lineHeight: '16px !important',
            color: `${theme.palette.primary.mainText2} !important`,
        },
        '& .MuiInput-root input:-webkit-autofill': {
            WebkitBoxShadow: "0 0 0 1000px transparent inset !important",
            WebkitTextFillColor: `#545456 !important`,
        },
        '& .MuiInput-underline:before': {
            color: `${theme.palette.primary.mainText2} !important`,
            borderBottom: `1px solid ${theme.palette.primary.mainText2} !important`,
            caretColor: `${theme.palette.primary.mainText2} !important`,
        },
        '& .MuiInput-underline:after': {
            color: `${theme.palette.primary.mainText2} !important`,
            borderBottom: `1px solid ${theme.palette.primary.mainText2} !important`,
            caretColor: `${theme.palette.primary.mainText2} !important`,
        },
        '& input[type=text]:hover ': {
            color: `${theme.palette.primary.mainText2} !important`,
            borderBottom: `1px solid ${theme.palette.primary.mainText2} !important`,
            caretColor: `${theme.palette.primary.mainText2} !important`,
        },
    },

    continueButton: {
        background: `${theme.palette.tertiary.provisionEnableButton} !important`,
        color: '#fff !important',
        textAlign:'center',
        width:'100%',
        padding:'12px',
        lineHeight: "28px",
        textTransform:'none',
        borderRadius: '8px',
        fontSize: '16px'
    },
    disableContinueButton:{
        background: `#BABEC3 !important`,
        color: '#6B7073 !important',
        textAlign:'center',
        width:'100%',
        padding:'12px',
        lineHeight: "28px",
        textTransform:'none',
        borderRadius: '8px',
        fontSize: '16px',
        position: 'sticky',
        bottom: '16px'
    },
    AddSiteButton:{
        display: 'flex',
        justifyContent: 'center',
        padding: '16px 0px',
        '&::after' :{
            content: '""',
            position: "absolute",
            width: "100%",
            height: "17px",
            bottom: "-17px",
            backgroundColor: `${theme.palette.primary.background} !important`,
        },
        '&::before' :{
            content: '""',
            position: "absolute",
            width: "100%",
            height: "16px",
            bottom: "52px",
            backgroundColor: `${theme.palette.primary.background} !important`,
        }
    },
    siteCountryData: {
        display: "flex",
        alignItems: "center", 
        justifyContent: "space-between",
        fontSize: "12px !important", 
        fontWeight: "400",
        minHeight: "42px",
    },
    siteCountryInput: {
        display: "flex", 
        alignItems: "flex-start",
        flexDirection: "column",
        gap: "4px",
        color: `${theme.palette.primary.mainText2} !important`,
        "& p": {
            fontSize: '9px',
            margin: '4px 0',
        },
    },
    siteCountryInputInit:{
        display: "flex",
        flexDirection: "row",
        margin:"12px 0 6px",
        height: "16px",
        color: "#A9A9AA !important"
    },
    horizantalRule:{
        margin: "0",
    },
    horizRuleW: {
        paddingTop: "4px",
    },
    horizRuleWo: {
        paddingTop: "0",
    },
    drawerBox:{
        '& .MuiDrawer-paperAnchorBottom' :{
            maxHeight: "75%",
        },
    },
    siteCountryDrawerHeader:{
        display: "flex", 
        alignItems: "center", 
        flexDirection:"row", 
        justifyContent: "space-between", 
        borderBottomStyle: "solid", 
        padding: "16px",
        position: "sticky",
        fontWeight:"500",
        top: "-0.5px",
        background: `${theme.palette.tertiary.drawerBackgroundV2} !important`,
        color: `${theme.palette.tertiary.cardText} !important`,
        zIndex: "10",
    },
    noDataContainer:{
        padding: '14px',
    },
    loaderContainer:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: "20px 15px",
    },
    noCountrySelectedMessage:{
        display: "flex", 
        alignItems: "center",  
        padding: "40px 15px",
        fontWeight: '400',
        fontFamily: 'Visuelt',
        background: `${theme.palette.tertiary.drawerBackgroundV2} !important`,
        color: `${theme.palette.tertiary.cardText} !important`,
    },
    siteCountryRadioBox:{
        padding: "16px 16px 20px 16px",
        background: `${theme.palette.tertiary.drawerBackgroundV2} !important`,
        '& .MuiRadio-root ': {
            color: `${theme.palette.tertiary.cardText} !important`,
        },
        color: `${theme.palette.tertiary.cardText} !important`,
    },
    siteCountryConfirmBtn:{
        background: "#01B5DE !important" ,
        margin: " 0 16px 16px",
        padding: "12px 24px",
        borderRadius: "8px",
        textTransform: 'none',
        fontSize: "16px",
        fontWeight: "500",
        color: "#FFFFFF",
        boxShadow:"none",
    },
    siteCountryDisableBtn:{
        background: `${theme.palette.tertiary.provisionDisableButton} !important`,
        margin: " 0 16px 16px",
        padding: "12px 24px",
        borderRadius: "8px",
        textTransform: 'none',
        fontSize: "16px",
        fontWeight: "500",
        color: "#FFFFFF",
        boxShadow:"none",
    },
    confirmButtonBox:{
        background: `${theme.palette.tertiary.drawerBackgroundV2} !important` ,
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        bottom: "0"
    },
    siteCountryInputAfter:{
        fontSize: "9px",
        fontWeight: "400",
        color: "#A9A9AA !important"
    },
    asteriskStyle:{
        position: "relative",
        fontSize: "1em", 
        marginLeft: "2px",
    },
    popUpBox:{
        width: '100%',
    },
    popUpHeader:{
        height: "55px",
        borderBottom: "1px solid",
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        paddingLeft: "15px",
        fontWeight: "400"
    },
    popUpContent:{
        display: "flex",
        flexDirection: "column",
        alignItems:"center",
        padding: "20px 20px 10px",
    },
    popUpMessage:{
        display: "flex",
        flexDirection: "column",
        textAlign:"center",
        fontSize:"12px",
        fontWeight:"400",
        margin: "10px 0 20px 0",
        gap: "6px",
    },
    actionBtn:{
        fontSize:"14px",
        width: "180px",
        padding: "10px 20px",
        border: "1px solid",
        borderRadius: "12px",
        color: "white",
        background: "#01B5DE",
        textAlign: "center",
    },

    toastMsg: {
        position: 'absolute',
        top: '64px',
        zIndex: '100',
    },

    loaderBtn: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: '100%',
        padding: '4px'
    },

    CloseBtn: {
        marginLeft: 'calc(100% - 32px)',
        paddingTop: '8px',
        fontSize: '20px', 
        color: `${theme.palette.tertiary.closeIconColor} !important`,
    },

    doneBtn: {
        backgroundColor: '#01b5de ',
        borderRadius: '16px',
        color: '#ffffff',
        textAlign: 'center',
        alignItems: 'center',
        opacity: '100%',
        padding: '13px ',
        margin: '16px',
        marginTop: '0px',
    },

    error: {
        color: 'red',
        marginTop: '16px',
    },

    //POPUP CONTENT CSS

    popupRoot: {
        width: 'auto',
        height: 'auto',
    },
    popupHeader: {
        color: theme.palette.primary.mainText,
        fontWeight: 'bold',
        fontSize: '20px',
        textAlign: 'center',
        padding: '30px',
        wordBreak: 'break-word',
        ...fontClasses.title1
    },
    popupButton: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '48px',
        fontSize: '16px',
        cursor: 'pointer',
        ...fontClasses.title2
    },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'row',
    },

    infoIcon: {
        display: 'flex',
        justifyContent: 'center',
    },

    renamepopupheading: {
        color:theme.palette.primary.text,
        opacity: '100%',
        fontWeight: '400',
        fontSize: '1.32px',
        margin: '16px',
        display: 'flex',
        justifyContent: 'center',
    },

    root: {
        margin: '32px',
        display: 'flex',
        '& .MuiInput-underline:before': {
            borderBottom: '2px solid #00B4DE',
        },
        '& .MuiInput-underline:after': {
            borderBottom: '2px solid #00B4DE',
        },
    },

    renamewifisavebtn: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#01b5de',
        borderRadius: '32px ',
        color: '#ffffff',
        opacity: '100% ',
        padding: '8px ',
        with: '100%',
        margin: '0 48px',
        marginBottom: "17px"

    },
    renamewificanclebtn: {
        display: 'flex',
        justifyContent: 'center',
        color: '#01b5de',
        padding: '8px ',
        marginTop: '16px',
        marginBottom: '16px',
    },

    errorMessage: {
        margin: '-29px 32px 16px',
        color: 'red',
        fontSize: '13px'
    },

    //viewEvDetails

    viewdetailscontainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        marginTop: '112px'
    },
    imagecontainer: {
        margin: '48px',
        borderRadius: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '144px',
        width: '144px'
    },
    ownerName: {
        marginTop: '-40px',
        fontWeight: '500',
        fontSize: '21px',
        color: '#545456',
        opacity: ' 100%',
    },

    NoDetailsfound: {
        marginTop: '-16px',
        fontWeight: '500',
        fontSize: '21px',
        color: '#545456',
        opacity: ' 100%',
    },
    detailscontainer: {
        margin: '32px -32px',
        justifyContent: 'space-around',
        display: 'flex',
        width: '100%',
        padding: '16px'


    },
    dataheading: {
        color: '#939598',
        marginBottom: '13px',
    },
    data: {
        color: '#6F6F6F',
        marginBottom: '13px',
        marginLeft: '-64px',
        fontWeight: '500',
    },

    errorimagecontainer: {
        margin: '48px',
        marginTop: '10px',
        borderRadius: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        height: '144px',
        width: '144px'
    },
    errorMsg: {
        margin: '32px',
        marginTop: '16px',
        textAlign: 'center',
        color: '#7B8793',
    },

    viewEvdetailsbtn: {
        backgroundColor: '#01b5de',
        borderRadius: '8px ',
        color: '#ffffff',
        textAlign: 'center',
        alignItems: 'center',
        opacity: '100% ',
        padding: '16px ',
        margin: '16px',
        marginTop: '128px',
    },
    marginB: {
        marginBottom: "17px"
    },
    listBox: {
        cursor: 'default',
        padding: '0 4px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        lineHeight: '30px',
        textAlign: 'left',
        borderTop: '1px solid #e6e6e6',
        fontSize: '14px',
        color:`${theme.palette.tertiary.inputText} !important`,
        width: "auto"

    },
    mainlistBox: {
        zIndex: ' 10000 !important',
        width: 'auto !important',
        right: '0px !important',
        display: 'block !important',
        backgroundColor: `${theme.palette.tertiary.card} !important`,
        maxWidth: '100vw',
    },
    redErrorMessage: {
        color: `${theme.palette.tertiary.errorMessageColor} !important`,
        fontSize: "12px !important",
        fontWeight: "400",
    },
    siteDetails: {
        margin: "16px 0",
        color: `${theme.palette.tertiary.cardText} !important`,
    }

}));


export { useStyles }

export const ActionItem = styled('div')({
    width: '100%',
    border: 'solid 1px',
    borderColor: '6F6F6F',
    display: 'flex',
    textAlign: 'center',
    borderStyle: 'groove none none none',
    '&>div:nth-child(1)': {
        flex: .5,
        color: '#6F6F6F',
        fontWeight: '400',
        fontFamily: 'Visuelt',
        border: 'solid 1px',
        borderColor: '',
        borderStyle: 'none groove none none',
        padding: '16px',
    },
    '&>div:nth-child(2)': {
        flex: .5,
        color: '#01b5de',
        fontWeight: '500',
        fontFamily: 'Visuelt',
        padding: '16px',
    }
});
